import type { BrandedIdentifier } from '../brandedIdentifier';

export type { ExerciseId } from '../exercises/exercises.branded';
export { toExerciseId } from '../exercises/exercises.branded';

export type ExerciseQueueUuid = BrandedIdentifier<'ExerciseQueue', string>;
export type ExerciseQueueCurrentItemId = BrandedIdentifier<'ExerciseQueueCurrentItem', number>;
export type ExerciseQueueItemId = BrandedIdentifier<'ExerciseQueueItem', number>;
export type ExerciseAttemptId = BrandedIdentifier<'ExerciseAttempt', number>;

export const toExerciseQueueUuid = (value: string): ExerciseQueueUuid => value as ExerciseQueueUuid;

export const toExerciseQueueCurrentItemId = (value: number): ExerciseQueueCurrentItemId => value as ExerciseQueueCurrentItemId;

export const toExerciseQueueItemId = (value: number): ExerciseQueueItemId => value as ExerciseQueueItemId;

export const toExerciseAttemptId = (value: number): ExerciseAttemptId => value as ExerciseAttemptId;
